module.exports = __webpack_public_path__ + "od-black-checkbox/od-black-checkbox-69b46856e0e827a18b9c2583297dc9c0.svg";